import { render, staticRenderFns } from "./wl-images.vue?vue&type=template&id=2c4a279c&scoped=true&lang=pug"
import script from "./wl-images.js?vue&type=script&lang=js&external"
export * from "./wl-images.js?vue&type=script&lang=js&external"
import style0 from "./wl-images.styl?vue&type=style&index=0&id=2c4a279c&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a279c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c4a279c')) {
      api.createRecord('2c4a279c', component.options)
    } else {
      api.reload('2c4a279c', component.options)
    }
    module.hot.accept("./wl-images.vue?vue&type=template&id=2c4a279c&scoped=true&lang=pug", function () {
      api.rerender('2c4a279c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-images/wl-images.vue"
export default component.exports